import { Box, Close, Heading, useBreakpointIndex } from '@apia/theme';
import React, { FC } from 'react';
import { responsive, spacing } from '@apia/theme';

export interface IDialogHeader {
  className?: string;
  close: () => void;
  hideCloseButton?: boolean;
  id?: string;
  NavBar?: React.ReactNode;
  title?: string;
}

declare global {
  interface Window {
    BTN_CLOSE: string;
  }
}

const DialogHeader: FC<IDialogHeader> = ({
  className,
  close,
  hideCloseButton,
  id,
  NavBar,
  title = '',
}) => {
  const breakpointIndex = useBreakpointIndex();

  const Title = (
    <Heading
      as="h3"
      sx={{
        wordBreak: 'break-word',
        m: '0',
        flex: '2 0',
        color: 'title',
      }}
      className="modal__title"
      id={id ? `modal-${id}-title` : ''}
    >
      {title}
    </Heading>
  );

  const CloseButton = React.useMemo(
    () =>
      hideCloseButton ? null : (
        <Close
          role="button"
          type="button"
          aria-label={window.BTN_CLOSE}
          onClick={close}
          title={window.BTN_CLOSE}
          sx={{
            mr: 'unset',
          }}
          className="modal__closeButton"
          data-test-id="close"
        />
      ),
    [close, hideCloseButton],
  );

  const NavBarElement = NavBar && (
    <Box
      sx={{
        display: 'flex',
        gap: responsive({ 0: 2, 1: '3px', 2: 2 }),
        justifyContent: 'end',
        flexDirection: responsive({ 0: 'row', 1: 'column', 3: 'row' }),
        width: responsive({ 0: 'auto', 1: '100%', 2: 'auto' }),
        flexBasis: 'max-content',
        height: '100%',
      }}
      className="modal__headerBar"
    >
      {NavBar}
    </Box>
  );

  return breakpointIndex > 3 ? (
    <Box
      className={`${className} modal__header`}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start',
        mb: spacing(0),
        justifyContent: 'space-between',
        width: '100%',
        gap: spacing(2),
        flexWrap: 'nowrap',
      }}
    >
      {Title}
      {NavBarElement}
      {CloseButton}
    </Box>
  ) : (
    <Box
      className={`${className} modal__header`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: responsive({ 0: 'center', 2: 'end' }),
        mb: spacing(0),
        justifyContent: 'space-between',
        width: '100%',
        gap: spacing(2),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
        }}
      >
        {Title}
        {CloseButton}
      </Box>
      {NavBarElement}
    </Box>
  );
};

export default DialogHeader;
